import React from 'react';
import {useField} from 'formik';

interface Props {
  fieldName: string;
  testId?: string;
}

const FormikErrorText = ({fieldName, testId}: Props) => {
  const [, meta] = useField(fieldName);

  let error = meta.error;
  // We sometimes have multiple errors in an array, but if we have an array of objects then
  // it is nested field errors and we don't want to do anything with those.
  if (Array.isArray(meta.error) && typeof meta.error[0] === 'string') {
    error = meta.error.join(', ');
  }

  if (!meta.touched || !error || typeof error !== 'string') {
    return null;
  }

  return (
    <div className="shared-error-text" role="alert" data-testid={testId}>
      {error}
    </div>
  );
};

export default FormikErrorText;
